import { defineStore } from "pinia";
import { ApiSup } from "@/Functions/ApiSupport";
import { useAuthStore } from '@/auth/auth'
import axios from 'axios'
import { th } from "date-fns/locale";

export const useUserStore = defineStore('useUserStore',{
  state: () => ({
    User: [],
  }),
  actions:{
    async ChangePasswordAPI(body){


            const authStore = useAuthStore()

            try {
              const response = await axios.put(
                `${import.meta.env.VITE_HOST_API}/api/user/change-password`,
                body,
                {
                  headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${authStore.token}`,
                  }
                }
              )
              // return response.data.status

              return { success: true, data: response.data.message}

            } catch (error) {
              console.error('Error updating event:', error.response.data.message)
              return { success: false, data: error.response.data.message}
              throw error
            }


    },


  }
})
